import { render, staticRenderFns } from "./client-autocomplete.vue?vue&type=template&id=6b612f86&"
import script from "./client-autocomplete.vue?vue&type=script&lang=js&"
export * from "./client-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports